import { useQueryClient } from 'react-query'

export const useInvalidateTPPChangeLogQuery = () => {
    const queryClient = useQueryClient()

    const invalidateTPPChangeLogQuery = async (tppId?: string) => {
        const queryKey = ['tppChangeLog']
        if (tppId) {
            queryKey.push(tppId)
        }
        await queryClient.invalidateQueries({
            queryKey,
            exact: false,
            refetchActive: true,
            refetchInactive: true,
        })
    }

    return { invalidateTPPChangeLogQuery }
}
